import { BehaviorSubject, Subscription } from 'rxjs';
import { HostService } from '../host/host.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PdvService {
  subscriptions: Subscription[] = [];
  pdvs: any[] = [];
  db: any;
  host: string;
  // idPdv = 'b29Ba0N2OE8wNFVjeGREbmI0UVdaZz09'
  // RFRpN2ZlRHByUzFqYU5yQ01ia0IvUT09
  // RXlUYUE5U014YWFiVFRUZUcwYkpBZz09
  idPdv = 'WE12M1Vqa0NGSGFXMGQzUmtBcmdOdz09';
  public static port=4052;
  public static googleId="334425176163-1h6236sf1js0hnbt6h6mnj3ise151ucn.apps.googleusercontent.com";
  public static facebookId="709832696363022";
  public pdv: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public orderTypes: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public orderTypesAvailability: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public nbrOffersAuthorizedSite: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  constructor(private http: HttpClient, private hostService: HostService) {
    this.host = this.hostService.host;
  }


  getTimes(orderType) {
    return new Promise((resolve, reject) => {
      let sub1 = this.orderTypes.subscribe((orderTypes) => {
        if (orderTypes.length > 0) {
          let index = orderTypes.findIndex(o => o.id === orderType);
          if (index > -1) {
            let avail = orderTypes[index];
            let dateDb = (avail.middayStartSite) ? this.getDate(avail.middayStartSite) : null;
            let dateFin = (avail.middayEndSite) ? this.getDate(avail.middayEndSite) : null;
            let dateDb2 = (avail.eveningStartSite) ? this.getDate(avail.eveningStartSite) : null;
            let dateFin2 = (avail.eveningEndSite) ? this.getDate(avail.eveningEndSite) : null;
            let times = [];
            if (dateDb && dateFin) {
              times = times.concat(this.getTimesArray(dateDb, dateFin, avail.minDelay));
            }
            if (dateDb2 && dateFin2) {
              times = times.concat(this.getTimesArray(dateDb2, dateFin2, avail.minDelay));
            }
            resolve(times);
          } else {
            resolve([]);
          }
        } else {
          resolve([]);
        }
      })
      this.subscriptions.push(sub1);
    })
  }

  getDate(fullDate) {
    let now = new Date();
    let arr = fullDate.split(/[- : T]/);
    let date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), arr[3], arr[4], 0);
    return date;
  }

  getTimesArray(dateDb, dateFin, maxDelay) {
    let now = new Date();
    let date = new Date();
    if (dateDb > dateFin) {
      date.setDate(date.getDate() + 1);
      dateFin.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    }
    let dateMin = (dateDb > now) ? new Date(dateDb.getTime() + maxDelay * 60000) : new Date(now.getTime() + maxDelay * 60000);
    let dateMax = new Date(dateFin.getTime());
    dateMin.setSeconds(0, 0);
    dateMax.setSeconds(0, 0);
    let i = dateMin;
    let times = [];
    while (i < dateMax) {
      times.push(i);
      i = new Date(i.getTime() + 300000);
    }
    return times;
  }


  getModesByPdv() {
    return this.http.get(this.host + 'ordertypes');
  }
  getPdv() {
    return this.http.get(this.host + 'pdv');
  }
  getPdvInfo() {
    return this.http.get(this.hostService.host + 'pdv/miniInfo');
  }
  checkAuthorizedCity(postalCode) {
    return this.http.post(this.host + 'authorizedCity', { postalCode: postalCode })
  }
  getAuthorizedCities() {
    return this.http.get(this.host + 'authorizedCities')
  }
  getPaymentModes(chosenOrderType) {
    return this.http.get(this.host + 'paymentmodes/ordertype/' + chosenOrderType);
  }
  getCompositionsOfCarte() {
    return this.http.get(this.hostService.host + 'ingredients/compositions');
  }

  ngOnDestroy() {
    this.unsubscribe();
  }
  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }
}
